var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRadio = function SvgRadio(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66663 23C2.6416 23 1 21.3584 1 19.3334V9.25015C1 7.22513 2.6416 5.58353 4.66663 5.58353H17.2126L18.8154 1.57646C19.0034 1.10642 19.5369 0.877789 20.0069 1.06581C20.477 1.25383 20.7056 1.78729 20.5176 2.25734L19.1871 5.58353H19.3331C21.3581 5.58353 22.9998 7.22513 22.9998 9.25015V19.3334C22.9998 21.3584 21.3581 23 19.3331 23H4.66663ZM17.854 7.41684H19.3331C20.3456 7.41684 21.1664 8.23764 21.1664 9.25015V19.3334C21.1664 20.3459 20.3456 21.1667 19.3331 21.1667H4.66663C3.65412 21.1667 2.83331 20.3459 2.83331 19.3334V9.25015C2.83331 8.23764 3.65412 7.41684 4.66663 7.41684H17.8118C17.8259 7.41717 17.84 7.41716 17.854 7.41684ZM15.5 18C17.433 18 19 16.433 19 14.5C19 12.567 17.433 11 15.5 11C13.567 11 12 12.567 12 14.5C12 16.433 13.567 18 15.5 18Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRadio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/radio.c1dc0bbcb08608137acce2b690fafef7.svg";